import React from 'react';
import { FaStore } from 'react-icons/fa';
import ApiImage from './ApiImage';
import Sponsor from '../../types/sponsor';

type Props = {
  sponsor: Sponsor;
  onClick: () => void;
};

/** 2×1 tile inside a row grid — spans two columns; height matches one photo via stretch. */
export default function AlbumSponsorItem({ sponsor, onClick }: Props) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="relative col-span-2 m-0 h-full min-h-0 w-full min-w-0 appearance-none overflow-hidden rounded-lg border-0 bg-transparent p-0 transition-opacity hover:opacity-90">
      {sponsor.logo ? (
        <ApiImage src={sponsor.logo} alt={sponsor.name} className="absolute inset-0 h-full w-full object-cover" />
      ) : (
        <div className="absolute inset-0 flex items-center justify-center">
          <FaStore className="h-10 w-10 text-primary/50" />
        </div>
      )}
    </button>
  );
}
